export default __webpack_public_path__ + "static/media/Card-GemEssential.dbf92805.png";